<template>
  <div class="footer_tab">
    <div class="tab_list">
      <div
        v-for="item in tabList"
        :key="item.id"
        class="tab_item"
        :class="activeId == item.id ? 'tab_active' : ''"
        @click="changeTab(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    activeId: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      tabList: [
        // {
        //   id: 2,
        //   path: "/",
        //   name: "行业报告",
        // },
        // {
        //   id: 1,
        //   path: "index",
        //   name: "汽车行业主要问题",
        // },
        // {
        //   id: 3,
        //   path: "/home",
        //   name: "凯众问答",
        //   // url: "http://report.ouraivision.com/",
        //   // url: "/",
        // },
        // {
        //   id: 4,
        //   path: "/news",
        //   name: "行业新闻",
        // },
      ],
    };
  },
  watch: {
    "$store.state.mystate.tabList": {
      // watch里面不能用箭头函数
      handler: function (newVal, oldVal) {
        this.tabList = this.$store.state.mystate.tabList;
      },
      deep: true,
    },
  },
  mounted() {
    this.tabList = this.$store.state.mystate.tabList;
  },
  methods: {
    changeTab(item) {
      if (item.url) {
        window.location.href = item.url;
      } else {
        this.$router.push({
          path: item.path,
        });
      }
    },
  },
};
</script>

<style scoped>
.footer_tab {
  /* position: fixed;
  left: 0;
  bottom: 0; */
  width: 100%;
  background: #fff;
}
.tab_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 10px 22px 16px 22px;
}
.tab_item {
  flex: 1;
  cursor: pointer;
  text-align: center;
  padding: 0 12px;
  font-size: 13px;
  border: 1px solid rgb(236, 237, 239);
  border-radius: 19px;
  line-height: 1;
  color: #333333;
  height: 38px;
  line-height: 38px;
  box-sizing: border-box;
  /* width: 78px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 6px;
}
.tab_item:last-child{
  margin-right: 0;
}
.tab_active {
  position: relative;
  color: #FEFEFE;
  background: #145DFF;
}
/* .tab_active::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background: #0077e6;
  bottom: 0;
  left: 0;
} */
</style>



// WEBPACK FOOTER //
// src/components/footer.vue